import jwt_decode from "jwt-decode";
import {
  setStateLoginComplete,
  setStateLogin,
  getStateLoginComplete,
} from "../containers/LayoutHome/stateLogin";
import { AES, enc } from "crypto-js";
import { client } from "../App";
import { REFRESH_TOKEN, LOG_OUT_USER } from "../GraphQL/Mutations";
import { ROLES_LABEL } from "./RolesConstants";
import { NotificationManager } from "react-notifications";

let refreshTokenTimeout = null;

export const cookie = {
  get(token) {
    let tokenstringJSON = window.sessionStorage.getItem(token);
    let tokenstring = JSON.parse(tokenstringJSON)?.accessToken;
    let StateLoginComplete = getStateLoginComplete();
    if (StateLoginComplete === "" && tokenstring) {
      let tokenstringDecrypted = AES.decrypt(
        tokenstring,
        process.env.ENCRYPTION_KEY
      ).toString(enc.Utf8);
      let TokenDecryp = decrypJWT(tokenstringDecrypted);
      let roleId = JSON.parse(TokenDecryp.roleId);
      setStateLoginComplete({
        userId: parseInt(TokenDecryp.userId),
        displayName: TokenDecryp.displayName,
        email: TokenDecryp.email,
        userName: TokenDecryp.userName,
        roleDescription: ROLES_LABEL[roleId[0]],
        roleId: roleId[0],
        tenantId: TokenDecryp.tenantId,
        clientId: parseInt(TokenDecryp.clientId),
        exp: TokenDecryp.exp,
      });
      setStateLogin(TokenDecryp.userName);
    }
    if (tokenstring) {
      let bytes = AES.decrypt(tokenstring, process.env.ENCRYPTION_KEY);
      return decrypJWT(bytes.toString(enc.Utf8));
    } else {
      return null;
    }
  },
  getToken(token) {
    if (token) {
      let tokenEncryptedJSON = window.sessionStorage.getItem(token);
      let tokenEncrypted = JSON.parse(tokenEncryptedJSON)?.accessToken;
      if (tokenEncrypted) {
        let bytes = AES.decrypt(tokenEncrypted, process.env.ENCRYPTION_KEY);
        return bytes.toString(enc.Utf8);
      }
      return undefined;
    } else {
      return null;
    }
  },
  getRefreshToken(token) {
    if (token) {
      let tokenEncryptedJSON = window.sessionStorage.getItem(token);
      let tokenEncrypted = JSON.parse(tokenEncryptedJSON)?.refreshToken;
      if (tokenEncrypted) {
        let bytes = AES.decrypt(tokenEncrypted, process.env.ENCRYPTION_KEY);
        return bytes.toString(enc.Utf8);
      }
      return undefined;
    } else {
      return null;
    }
  },
  set(nameCookie, json) {
    let refreshToken = json.refreshToken;
    let accessToken = json.accessToken;
    let TokenDecryp = decrypJWT(accessToken);
    startRefreshTokenTimer(TokenDecryp.exp);
    let ciphertextAccess = AES.encrypt(
      accessToken,
      process.env.ENCRYPTION_KEY
    ).toString();
    let ciphertextRefresh = AES.encrypt(
      refreshToken,
      process.env.ENCRYPTION_KEY
    ).toString();
    let data = {
      accessToken: ciphertextAccess,
      refreshToken: ciphertextRefresh,
    };
    window.sessionStorage.setItem(nameCookie, JSON.stringify(data));
    let roleId = JSON.parse(TokenDecryp.roleId);
    setStateLoginComplete({
      userId: parseInt(TokenDecryp.userId),
      displayName: TokenDecryp.displayName,
      email: TokenDecryp.email,
      userName: TokenDecryp.userName,
      roleDescription: ROLES_LABEL[roleId[0]],
      roleId: roleId[0],
      tenantId: TokenDecryp.tenantId,
      clientId: parseInt(TokenDecryp.clientId),
      exp: TokenDecryp.exp,
    });
    setStateLogin(TokenDecryp.userName);
  },
};

export const decrypJWT = (Token) => {
  return jwt_decode(Token);
};

export const removeJWTCookie = () => {
  window.sessionStorage.clear();
};

export const startRefreshTokenTimer = (expires) => {
  clearTimeout(refreshTokenTimeout);
  const token = cookie.get("TrustSafety");
  if (token) {
    const { exp } = token;
    const expiredTime = new Date(exp * 1000).getTime();
    const currentTime = new Date().getTime();
    const time = expiredTime - currentTime - 600000; // fecha expiracion - fecha actual - 10min
  refreshTokenTimeout = setTimeout(() => {
    getNewToken()
      .then((res) => {
        if (res?.data?.userRefreshToken?.loginSuccess) {
          cookie.set("TrustSafety", res.data.userRefreshToken);
          // Reiniciar el temporizador con el nuevo tiempo de expiración si es necesario
          startRefreshTokenTimer(res.data.userRefreshToken.expiresIn);
        } else {
          logOutApp();
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
    }, time);
  }
};

export const stopRefreshTokenTimer = () => {
  clearTimeout(refreshTokenTimeout);
};

export const getNewToken = async () => {
  const response = await client.mutate({
    mutation: REFRESH_TOKEN,
    variables: {
      refreshToken: cookie.getRefreshToken("TrustSafety"),
    },
    context: { clientName: "LinkUsers" },
  });
  return response;
};

const logOutAppRedirectHome = () => {
  removeJWTCookie(); //"TrustSafety"
  stopRefreshTokenTimer();
  if (window.location.pathname === "/ICE") {
    window.location.href = "/ICE";
  } else {
    window.location.href = "/";
  }
};

export const logOutApp = () => {
  logoutUserMutation()
    .then((res) => {
      logOutAppRedirectHome();
    })
    .catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
      logOutAppRedirectHome();
    });
};

const logoutUserMutation = async () => {
  const response = await client.mutate({
    mutation: LOG_OUT_USER,
    variables: {
      refreshToken: cookie.getRefreshToken("TrustSafety"),
    },
    context: { clientName: "LinkUsers" },
  });
  return response;
};
